import { territoriesByAbbrev, statesByAbbrev } from '@scoir/states'

export type SchoolType = 'public' | 'private'
export type Title1Program = 'swp' | 'tas'

type Territories = keyof typeof territoriesByAbbrev
type States = keyof typeof statesByAbbrev
export const unknownLocation = '' as const
type UnknownLocation = typeof unknownLocation
export type HSLocation = Territories | States | UnknownLocation

export const RELIGIOUS_AFFILIATION_OPTIONS = [
  'Other',
  'Roman Catholic',
  'Islamic',
  'Christian (unspecified)',
  'Baptist',
  'Church of God',
  'Pentecostal',
  'Presbyterian',
  'Episcopal',
  'Seventh-Day Adventist',
  'Jewish',
  'Assembly of God',
  'Church of Christ',
  'Calvinist',
  'Methodist',
  'Mennonite',
  'Friends',
  'Lutheran Church-Missouri Synod',
  'Church of God in Christ',
  'African Methodist Episcopal',
  'Church of the Nazarene',
  'Brethren',
  'Wisconsin Evangelical Lutheran Synod',
  'Other Lutheran',
  'Evangelical Lutheran Church In America',
  'Latter Day Saints',
  'Amish',
  'Greek Orthodox',
  'Nonsectarian',
  '',
] as const

export type ReligiousAffiliation = (typeof RELIGIOUS_AFFILIATION_OPTIONS)[number]

export type APIFilters = {
  schoolType?: SchoolType
  isActive?: boolean
  minSize?: number
  maxSize?: number
  startDate?: string
  endDate?: string
  virtual?: boolean
  title1Program?: Title1Program
  isTitle1Eligible?: boolean
  pctFreeReducedLunchMin?: number
  pctFreeReducedLunchMax?: number
  text?: string
  locations?: HSLocation[]
  religiousAffiliation?: ReligiousAffiliation[]
}

export type UIFilters = {
  religiousAffiliation?: ReligiousAffiliation[]
  schoolType?: SchoolType
  isActive?: true
  isTitle1Eligible?: boolean
  classSize?: {
    min?: number
    max?: number
  }
  pctFreeReducedLunch?: {
    min?: number
    max?: number
  }
  visitRange?: {
    type: 'this-week' | 'this-month' | 'next-month' | 'custom'
    startDate?: Date
    endDate?: Date
  }
  virtual?: boolean
  title1Program?: 'swp' | 'tas'
  text?: string
  locations?: HSLocation[]
}

export const isValidSchoolType = (v?: string): v is SchoolType => v !== undefined && ['public', 'private'].includes(v)
